import type { DeepPartial } from '@luna/utils-ts';
import type { CardsFeatureConfig } from '@shared/cards-config';

import {
    CardBankHeaderFeatureConfig,
    CardBlockingFeatureConfig,
    CardDeliveryFeatureConfig,
    CardLimitsChangeFeatureConfig,
    CardsBankListFeatureConfig,
    CardsCreditLimitChangeFeatureConfig,
    CardsSettingsCardDetailsFeatureConfig,
    CreditCardContentBoxFeatureConfig,
    CreditSharedFeatureConfig,
    DebitCardContentBoxFeatureConfig,
    PinDeliveryFeatureConfig,
    ReprintPinFeatureConfig,
} from './featureConfig';

export const cards: DeepPartial<CardsFeatureConfig> = {
    isNativeAliasChangeAllowed: true,
    overview: {
        CREDIT: {
            AUTHORIZED: {
                hide: true,
            },
            AUTHORIZED_STANDALONE: {
                hide: true,
            },
            displayLimit: true,
        },
        BANK_CARD: {
            MAIN: {
                hide: true,
            },
            AUTHORIZED: {
                hide: true,
            },
            AUTHORIZED_STANDALONE: {
                hide: true,
            },
        },
    },
    credit: CreditSharedFeatureConfig.RO,
    bank: {
        showAsProduct: true,
        settings: {
            limitChange: false,
        },
    },
    bank_card: {
        settings: {
            allowPersonalization: false,
        },
    },
    shared: {
        functions: {
            tpLimits: {
                permanentAlwaysActive: true,
                payloadPrecision: 0,
            },
            limitChange: {
                displayInternetLimitFormField: true,
                displayATMLimitFormField: true,
                forbidFreeFormLimitAmountInput: true,
            },
        },
        settings: {
            sos: {
                preferFlag: true,
                showInfo: true,
            },
        },
    },
    components: {
        cardDelivery: CardDeliveryFeatureConfig.RO,
        pinDelivery: PinDeliveryFeatureConfig.RO,
        cardServices: {
            reprintPin: ReprintPinFeatureConfig.RO,
            replacementCardV2: {
                enabled: true,
                forcePhonePinDelivery: true,
                deliveryManagement: true,
            },
        },
        cardsList: CardsBankListFeatureConfig.RO,
        limitsChange: CardLimitsChangeFeatureConfig.RO,
        bankCardHeader: CardBankHeaderFeatureConfig.RO,
        cardBlocking: CardBlockingFeatureConfig.RO,
        creditCardLimitChange: CardsCreditLimitChangeFeatureConfig.RO,
        settings: {
            cardDetails: CardsSettingsCardDetailsFeatureConfig.RO,
        },
        creditCardContentBox: CreditCardContentBoxFeatureConfig.RO,
        debitCardContentBox: DebitCardContentBoxFeatureConfig.RO,
    },
    statements: {
        signed: true,
        showPhoneNumbersDropdown: false,
        reversibleToPaperDelivery: false,
        deliverySelectable: true,
    },
};
